import { Typography } from '@ghq-abi/design-system-v2';
import { useTranslate } from '@tolgee/react';
import { X } from 'lucide-react';

import { DialogTitle } from '~/components/ui/dialog';

interface ModalCloseHeaderProps {
  title: string;
  onClose: () => void;
  disabled?: boolean;
}

export function ModalCloseHeader({
  title,
  onClose,
  disabled = false
}: ModalCloseHeaderProps) {
  const { t } = useTranslate();

  return (
    <div className="flex items-center justify-between">
      <DialogTitle asChild>
        <Typography variant="title-sm-bold" color="dark">
          {title}
        </Typography>
      </DialogTitle>
      <button
        type="button"
        onClick={onClose}
        disabled={disabled}
        className="p-1 text-gray-400 hover:text-gray-600 rounded hover:bg-gray-100 transition-colors disabled:opacity-50"
        aria-label={t('common.close', 'Close')}>
        <X className="w-5 h-5" />
      </button>
    </div>
  );
}
